document.addEventListener('DOMContentLoaded', function () {
    const hamburger = document.querySelector('.ri-digital__hamburger');
    const closeBtn = document.querySelector('.ri-digital__close');
    const mobileMenu = document.querySelector('.ri-digital__mobile-menu');
    const menuItems = document.querySelectorAll('.mobile-menu-item');
    const submenus = document.querySelectorAll('.ri-digital__mobile-submenu');
    const backButton = document.querySelector('.ri-digital__back');
    const menuHeader = document.querySelector('.ri-digital__mobile-menu-header');
    let navigationStack = [];  // Pilha para armazenar o histórico de navegação
  
    // Verifica se os elementos existem antes de adicionar os eventos
    if (hamburger && closeBtn && mobileMenu) {
        // Abrir o menu mobile
        hamburger.addEventListener('click', () => {
            mobileMenu.classList.add('active');
            closeBtn.classList.add('active');  // Exibe o botão de fechar
        });

        // Fechar o menu mobile
        closeBtn.addEventListener('click', () => {
            mobileMenu.classList.remove('active');
            closeBtn.classList.remove('active');  // Oculta o botão de fechar
            submenus.forEach(submenu => submenu.classList.remove('active')); // Fechar todos submenus
            const mainMenu = mobileMenu.querySelector('.ri-digital__mobile-menu-main');
            if (mainMenu) {
                mainMenu.style.display = 'flex';
            }
            menuHeader?.classList.remove('submenu-open'); // Reseta o header
            navigationStack = [];  // Reseta a pilha de navegação
        });
    }

    // Navegar para submenus
    if (menuItems.length > 0 && mobileMenu) {
        menuItems.forEach(item => {

            //Se o link não tiver o atributo "data-target", é um link direto, então ele ignora no forEach.
            if (item.dataset.target === undefined) {
                return false;
            }

            item.addEventListener('click', (e) => {
                const targetSubmenu = document.querySelector(`#${item.getAttribute('data-target')}`);
                const mainMenu = mobileMenu.querySelector('.ri-digital__mobile-menu-main');
                if (mainMenu && targetSubmenu) {
                    mainMenu.style.display = 'none';
                    targetSubmenu.classList.add('active');
                    navigationStack.push(targetSubmenu);  // Adiciona o submenu à pilha de navegação
                    menuHeader?.classList.add('submenu-open'); // Adicionar a classe no menu-header
                }
            });
        });
    }

    // Voltar para o submenu anterior
    if (backButton) {
        backButton.addEventListener('click', () => {
            if (navigationStack.length > 0) {
                const currentSubmenu = navigationStack.pop();  // Remove o submenu atual da pilha
                currentSubmenu?.classList.remove('active');  // Esconde o submenu atual

                if (navigationStack.length === 0 && mobileMenu) {
                    const mainMenu = mobileMenu.querySelector('.ri-digital__mobile-menu-main');
                    if (mainMenu) {
                        mainMenu.style.display = 'flex';
                    }
                    menuHeader?.classList.remove('submenu-open');
                } else {
                    const previousSubmenu = navigationStack[navigationStack.length - 1];
                    previousSubmenu?.classList.add('active');
                }
            }
        });
    }

    const categories = document.querySelectorAll('.ri-digital__onr-category');
    const subcategories = document.querySelectorAll('.ri-digital__onr-subcategories');
    const onrBtn = document.querySelector('.ri-digital__onr-btn');
    const onrDropdown = document.querySelector('.ri-digital__onr-dropdown');
    const menuIcon = onrBtn?.querySelector('.ri-digital__menu-icon');

    if (onrBtn && onrDropdown && menuIcon) {
        // Função para definir a categoria ativa
        function setActiveCategory(category) {
            categories.forEach(cat => cat.classList.remove('active'));
            subcategories.forEach(sub => sub.style.display = 'none');
            category.classList.add('active');
            const targetCategory = category.getAttribute('data-category');
            const targetSubmenu = document.getElementById(targetCategory);
            if (targetSubmenu) {
                targetSubmenu.style.display = 'flex';
            }
        }

        // Inicializa a primeira categoria quando o dropdown é aberto
        function initializeDropdown() {
            if (categories.length > 0) {
                const firstCategory = categories[0];
                if (!firstCategory.classList.contains('active')) {
                    setActiveCategory(firstCategory);
                }
            }
        }

        // Evento para abrir o dropdown e inicializar a primeira categoria
        onrBtn.addEventListener('mouseenter', () => {
            menuIcon.style.transform = 'rotate(180deg)';
            onrBtn.style.backgroundColor = '';
            initializeDropdown();
        });

        onrDropdown.addEventListener('mouseenter', () => {
            menuIcon.style.transform = 'rotate(180deg)';
            onrBtn.style.backgroundColor = '';
        });

        onrDropdown.addEventListener('mouseleave', () => {
            menuIcon.style.transform = 'rotate(0deg)';
            onrBtn.style.backgroundColor = '';
        });

        onrBtn.addEventListener('mouseleave', () => {
            menuIcon.style.transform = 'rotate(0deg)';
            onrBtn.style.backgroundColor = '';
        });

        categories.forEach(category => {
            category.addEventListener('mouseenter', function () {
                setActiveCategory(this);
            });
        });
    }

    const botaoServicos = document.querySelectorAll("[data-js='botao-servicos']");
    const secaoServicos = document.querySelector("[data-js='secao-servicos']");

    if (botaoServicos.length > 0 && secaoServicos) {
        [...botaoServicos].forEach((item) => {
            item.addEventListener("click", e => {
                e.preventDefault();
                secaoServicos.scrollIntoView({ behavior: "smooth" });
            });
        });
    }

    const modal = document.getElementById('ri-digital_Modal_User');
    const overlay = document.getElementById('ri-digital_Modal_User-overlay');
    const closeBtnModal = document.querySelector('.ri-digital_Modal_User-close');
    const openModalBtn = document.getElementById('open-ri-digital_Modal_User');
    const menuIconModal = openModalBtn?.querySelector('.ri-digital__menu-icon');

    if (modal && overlay && closeBtnModal && openModalBtn && menuIconModal) {
        function openModal() {
            modal.style.display = 'flex';
            overlay.style.display = 'block';
            menuIconModal.classList.add('open');
        }

        function closeModal() {
            modal.style.display = 'none';
            overlay.style.display = 'none';
            menuIconModal.classList.remove('open');
        }

        openModalBtn.addEventListener('click', function (e) {
            e.preventDefault();
            openModal();
        });

        closeBtnModal.addEventListener('click', function () {
            closeModal();
        });

        overlay.addEventListener('click', function () {
            closeModal();
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                closeModal();
            }
        });
    }
});
